import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { buildBreadcrumbList } from '../lib/structuredData';
import { ArrowLeftIcon, HandshakeIcon, PhoneCallIcon, TargetIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const TeamLidJellePage: React.FC = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-2796" data-mp="1gj4o40eias4l">
      <SEO title="Jelle Zwaanenburg, Sales Executive | Noord Digital" description="Maak kennis met Jelle Zwaanenburg, Sales Executive bij Noord Digital. Eerste aanspreekpunt voor groeivragen en passende voorstellen." canonical="https://noorddigital.nl/over-ons/jelle" jsonLd={buildBreadcrumbList([{
      name: 'Over ons',
      path: '/over-ons'
    }, {
      name: 'Jelle Zwaanenburg',
      path: '/over-ons/jelle'
    }])} data-id="element-2797" data-mp="1kjybmso1e4wy" />
      <Header data-id="element-2798" data-mp="2487d5tbgzn94" />

      <main className="pt-32 pb-20 lg:pt-40 lg:pb-24" data-id="element-2799" data-mp="248qkkg3hut8w">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2800" data-mp="1q79mzdtr5zp2">
          <button onClick={() => navigate('/over-ons')} className="inline-flex items-center gap-2 text-[#004AC7] font-medium hover:underline mb-12" data-id="element-2801" data-mp="1q5f1nyekk5kg">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-2802" data-mp="1zymg08raevwo" /> Terug naar het team
          </button>

          <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-2803" data-mp="1v6m9tykmj6rn">
            <div className="lg:w-1/3 flex justify-center lg:justify-start" data-id="element-2804" data-mp="29vihvvmokjs9">
              <div className="w-[300px] h-[300px] rounded-full border-4 border-[#004AC7] overflow-hidden shadow-lg" data-id="element-2805" data-mp="29xv5opf4dod8">
                <img src="https://cdn.magicpatterns.com/uploads/5AvkpigfrYsv7QATg1Cgrc/WhatsApp_Image_2026-05-09_at_11.41.56.jpg" alt="Jelle Zwaanenburg" className="w-full h-full object-cover" style={{
                objectPosition: 'center 35%'
              }} data-id="element-2806" data-mp="2iwgqysbz7hhp" />
              </div>
            </div>

            <div className="lg:w-2/3" data-id="element-2807" data-mp="jjkwg4xd1bg3">
              <h1 className="text-4xl md:text-5xl font-bold text-[#111827] mb-2" data-id="element-2808" data-mp="jkmkd9zh5sf8">
                Jelle Zwaanenburg
              </h1>
              <p className="text-xl text-[#607697] font-medium mb-8" data-id="element-2809" data-mp="2jnorr7zhb83n">
                Sales Executive
              </p>

              <div className="prose prose-lg text-[#4B5563] mb-12" data-id="element-2810" data-mp="2tk08ca63qk3w">
                <p className="mb-4" data-id="element-2811" data-mp="2tluvlv4uiob5">
                  Als Sales Executive bij Noord Digital ben ik vaak het eerste
                  gezicht waar je mee praat. Ik draai de sales en zorg dat jouw
                  vraag goed begrepen wordt voordat we een voorstel doen.
                </p>
                <p className="mb-4" data-id="element-2812" data-mp="37hourmfthzb2">
                  Ik geloof niet in pushen of gladde verkooppraatjes. Een goed
                  gesprek begint met luisteren: wat speelt er bij jouw bedrijf,
                  waar wil je naartoe en wat is realistisch op korte termijn?
                  Pas daarna kijken we samen of Noord Digital de juiste partner
                  is.
                </p>
                <p data-id="element-2813" data-mp="3qakfts3y3t0a">
                  Mijn rol is om de brug te slaan tussen jouw groeivraag en het
                  team dat het werk uitvoert. Helder, eerlijk en met een
                  voorstel waar je écht iets aan hebt.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-[#111827] mb-6" data-id="element-2814" data-mp="15l7nttrybawo">
                Expertise
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2815" data-mp="10o7p63xflafl">
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2816" data-mp="1xdf0kj4c635s">
                  <PhoneCallIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2817" data-mp="1tbtpn3bd3yy8" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2818" data-mp="1tdxvvrwqha1o">Sales</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2819" data-mp="1oiqw2v6l4pi1">
                  <HandshakeIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2820" data-mp="1jlid4sdm4hfq" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2821" data-mp="2h27kf1lc0bwi">Klantcontact</h3>
                </div>
                <div className="bg-[#F7F8FA] p-6 rounded-xl border border-gray-100" data-id="element-2822" data-mp="2c9eh8i5ihbmj">
                  <TargetIcon className="w-8 h-8 text-[#004AC7] mb-4" data-id="element-2823" data-mp="1vungahk3shrl" />
                  <h3 className="font-bold text-[#111827]" data-id="element-2824" data-mp="20u03x4istsv8">
                    Voorstellen op maat
                  </h3>
                </div>
              </div>

              <a href="/#contact" className="inline-block bg-[#004AC7] text-white px-8 py-4 rounded-lg font-bold hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-2825" data-mp="1mw35e2ksbcdx">
                Neem contact op met Jelle
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-2826" data-mp="2jj7sq3a3km21" />
    </div>;
};